import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TutorialPage } from './tutorial';

@NgModule({
  declarations: [
    TutorialPage,
  ],
  imports: [
    IonicPageModule.forChild(TutorialPage),
  ],
})
export class TutorialPageModule {}



// WEBPACK FOOTER //
// ./src/pages/tutorial/tutorial.module.ts